import { createSelector, createSlice } from "@reduxjs/toolkit";

const organizationSlice = createSlice({
    name: "organization",
    initialState: {
        allIp: [],
        isLoading: false,
        allShifts: [],
        calendarEvents: []
    },
    reducers: {
        addIp: (state) => { },
        addedIp: (state, action) => {
            state.allIp.push(action.payload)
        },
        removeIp: (state, action) => { },
        removedIp: (state, action) => {
            const d = state.allIp.filter(d => d?._id !== action.payload)
            state.allIp = d;
        },
        updateIp: (state) => { },
        updatedIp: (state, action) => {
            const d = state.allIp.map(d => d?._id === action.payload._id ? action.payload : d)
            state.allIp = d;
        },
        listIp: (state) => {
            state.isLoading = true
        },
        storeIp: (state, action) => {
            state.allIp = action.payload
            state.isLoading = false
        },
        getCurrentIp: (state) => {

        },
        getRangeEvents:()=>{},


        createShift: () => { },
        listShifts: () => { },
        storeAllShift: (state, action) => {
            state.allShifts = action.payload
        },
        updateShift: () => { },

        createCalendarEvent: () => { },
        getCalendarEvent: () => { },
        storeCalendarEvent: (state, action) => {
            state.calendarEvents = action.payload
        },
        updateCalendarEvent: () => { },
        deleteCalendarEvent: () => { },


        clearAllOrgData: (state) => {
            state.allIp = [];
            state.isLoading = false
        }
    }
})


export const {
    addIp,
    addedIp,
    removeIp,
    getRangeEvents,
    removedIp,
    updateIp,
    updatedIp,
    listIp,
    storeIp,
    getCurrentIp,
    createShift,
    listShifts,
    storeAllShift,
    updateShift,


    createCalendarEvent,
    getCalendarEvent,
    storeCalendarEvent,
    updateCalendarEvent,
    deleteCalendarEvent,

    clearAllOrgData

} = organizationSlice.actions


export const allIpSelector = createSelector(
    state => state.organization,
    organization => organization
);
export const allShiftSelector = createSelector(
    state => state.organization,
    organization => organization.allShifts
);

export default organizationSlice.reducer;